export const state = () => {
  return {
    // 是否显示加密提示框
    isShowSecurityModal: false,
    // 加密的数据详情
    securityDetail: {},
    skus: [],
  }
}

export const actions = {
  switchProductStatus({ commit }, info) {
    if (info.status) {
      commit('SWITCH_PRODUCT_STATUS', {
        isShowSecurityModal: info.status,
        securityDetail: info.item,
      })
    } else {
      commit('SWITCH_PRODUCT_STATUS', {
        isShowSecurityModal: info.status,
      })
    }
  },
}

export const mutations = {
  // 刚开始, 最小起购量就是初始值
  skusInit(state, data) {
    console.log('skusInit', data)
    const skus = []
    data.map((item) => {
      skus[skus.length] = {
        quantity: 0,
        skucode: item.skucode,
      }
    })
    state.skus = skus
  },
  skusSet(state, data) {
    state.skus[data.index].quantity = data.quantity
  },
  SWITCH_PRODUCT_STATUS: (state, { isShowSecurityModal, securityDetail, securityCode }) => {
    if (isShowSecurityModal) {
      state.securityDetail = securityDetail
      state.isShowSecurityModal = isShowSecurityModal
    } else {
      state.isShowSecurityModal = isShowSecurityModal
    }
  },
}
